export default "__VITE_ASSET__Dp_H8V_V__"